"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.REVIEW_IDENTITY_REQUEST_EXAMPLE = exports.RESOLVE_IDENTITY_REQUEST_EXAMPLE = exports.reviewIdentityRequestSchema = exports.resolveIdentityRequestSchema = void 0;
const zod_1 = require("zod");
exports.resolveIdentityRequestSchema = zod_1.z.object({
    patientAId: zod_1.z.string().uuid(),
    patientBId: zod_1.z.string().uuid(),
});
exports.reviewIdentityRequestSchema = zod_1.z.object({
    candidateId: zod_1.z.string().uuid(),
    decision: zod_1.z.enum(['CONFIRM_DUPLICATE', 'REJECT']),
    reviewedBy: zod_1.z.string().uuid(),
});
exports.RESOLVE_IDENTITY_REQUEST_EXAMPLE = {
    patientAId: '22222222-2222-2222-2222-222222222222',
    patientBId: '33333333-3333-3333-3333-333333333333',
};
exports.REVIEW_IDENTITY_REQUEST_EXAMPLE = {
    candidateId: '77777777-7777-7777-7777-777777777777',
    decision: 'CONFIRM_DUPLICATE',
    reviewedBy: '99999999-9999-9999-9999-999999999999',
};
//# sourceMappingURL=identity-resolution.request.js.map